import { loadAll, on, getItems } from "./store.js";
import "./imageWall.js";
import "./incipit-search.js";
import { buildFacetUI } from "./filters.js";
import "./detail.js";

const catsFieldset = document.getElementById("cats");

await loadAll({ manifestUrl: "/data/manifest.json" });

on("data:ready", () => {
  if (catsFieldset) buildFacetUI(getItems(), catsFieldset);
});
